import i18n from '../i18n';

export const SHORTLINK_BASE_STORAGE_KEY = 'shortlink.redirect.base';
export const TENANT_STORAGE_KEY = 'shortlink.selected.tenant';
export const DEFAULT_REDIRECT_STORAGE_KEY = 'shortlink.pref.redirect.default';
export const CONFIRM_DELETE_STORAGE_KEY = 'shortlink.pref.confirm-delete';
export const URL_CODE_REGEX = /^[a-zA-Z0-9_-]{3,64}$/;

function activeLocale(): string {
  return i18n.language?.startsWith('it') ? 'it-IT' : 'en-US';
}

export function normalizeBaseUrl(rawValue: string): string {
  const trimmed = rawValue.trim();
  if (!trimmed) {
    return '';
  }

  const withProtocol = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;

  try {
    const url = new URL(withProtocol);
    const pathname = url.pathname.replace(/\/$/, '');
    return `${url.origin}${pathname}`.replace(/\/$/, '');
  } catch {
    return '';
  }
}

export function formatDate(value?: string): string {
  if (!value) {
    return '-';
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return '-';
  }

  return parsed.toLocaleString(activeLocale(), {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatCount(value: number): string {
  return new Intl.NumberFormat(activeLocale()).format(value);
}

export function formatBytes(bytes: number): string {
  if (bytes <= 0) {
    return '0 B';
  }

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let value = bytes;
  let unitIndex = 0;

  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }

  return `${value >= 10 || unitIndex === 0 ? value.toFixed(0) : value.toFixed(1)} ${units[unitIndex]}`;
}

export function formatRuntime(ms: number): string {
  if (ms <= 0) {
    return '-';
  }

  if (ms < 1000) {
    return `${ms} ms`;
  }

  return `${(ms / 1000).toFixed(1)} s`;
}

